<template>
  <Layout class="home">
    <Title
      title="Configurações de documentos"
      margin="large"
    />
    <fragment>
      <b-row
        cols="1"
        cols-md="3"
        cols-sm="2"
      >
        <b-col
          v-for="configuration  in configurations"
          :key="configuration.id"
        >
          <Button
            :upperCase=false
            type="clean"
            @click="() => editConfiguration(configuration)"
          >
            <card
              :title="getName(configuration.modelo)"
              :actions="actions(configuration)"
            >
              <div v-if="!isGerencial(configuration)">
                <b>Ambiente:</b>
                {{env(configuration.ambiente)}}
              </div>
              <div v-if="!isGerencial(configuration)">
                <b>Série:</b>
                {{configuration.serie}}
              </div>
              <div>
                <b>Próximo Documento:</b>
                {{configuration.proximaNota}}
              </div>
            </card>
          </Button>
        </b-col>
        <b-col>
          <Button
            full-width
            align="center"
            class="btn-fiscal-configuration"
            @click="() => editConfiguration(null)"
          >
            <icon-plus :size="18" />
            Nova configuração
          </Button>
        </b-col>
      </b-row>
    </fragment>

    <fragment>
      <Title
        title="Configurações de pagamento (Shipay)"
        margin="large"
        margin-top
      />

      <b-row
        cols="1"
        cols-md="3"
        cols-sm="2"
      >
        <b-col v-if="shipay">
          <Button
            type="clean"
            :upper-case="false"
            @click="() => editShipay()"
          >
            <card
              title="SHIPAY"
              :actions="actions(null, 'shipay')"
            >
              <div>
                <b>CLIENT ID:</b>
                {{shipay.clientId}}
              </div>
            </card>
          </Button>
        </b-col>
        <b-col v-else>
          <Button
            full-width
            align="center"
            class="btn-fiscal-configuration"
            @click="() => editShipay()"
          >
            <icon-plus :size="18" />
            Nova configuração
          </Button>
        </b-col>
      </b-row>
    </fragment>

    <ModalConfiguration
      v-model="modalConfigurations"
      :data="selected"
      :avaliableSat="isClientFromSP"
      :environments="ambientes"
      :save="handleSave"
    />

    <ModalShipay
      v-model="modalShipay"
      :data="shipay"
      :save="handleSaveShipay"
    />
  </Layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import IconTrash from 'vue-material-design-icons/TrashCan';
import IconPlus from 'vue-material-design-icons/Plus';

import { AMBIENTE_LABEL } from '../enums/Ambientes';
import { MODELO_LABEL, MODELO } from '../enums/Documento';

import Title from '../../../components/Title';
import Layout from '../../../components/Layout';
import Card, { CardActions } from '../../../components/Card';
import ModalConfiguration, { ModalConfigurationData } from '../components/ModalConfiguration';
import ModalShipay from '../components/ModalShipay';
import { Button } from '../../../components/Form';

import { ClientMixin } from '../../Application';
import AmbienteMixin from '../mixins/AmbienteMixin';

export default {
  name: 'FiscalConfiguration',
  mixins: [
    ClientMixin,
    AmbienteMixin,
  ],
  components: {
    IconPlus,
    Title,
    Card,
    ModalConfiguration,
    Button,
    Layout,
    ModalShipay,
  },
  data() {
    return {
      modalConfigurations: false,
      modalShipay: false,
      selected: new ModalConfigurationData({}),
      configurations: [],
      shipay: null,
    };
  },
  props: {
    confirm: {
      type: Function,
    },
  },
  mounted() {
    const getDataInit = async () => {
      this.setLoading(true);
      await this.getClient();
      await this.getAmbientes();
      const { data } = await this.$http.get('fiscal.get-configuracao');
      const { data: { data: shipay } } = await this.$http.get('fiscal.get-shipayConfiguration');
      this.shipay = shipay;
      this.configurations = data;
      this.setLoading(false);
    };
    getDataInit();
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    actions(configuration, action = null) {
      const actions = new CardActions();
      actions.addAction(
        IconTrash,
        () => {
          this.confirm({
            title: 'Remover configuração',
            message: 'Deseja realmente remover essa configuração?',
            onOk: async () => {
              const listActions = {
                shipay: async () => {
                  await this.$http.post('fiscal.delete-shipayConfiguration');
                  const { data: { data } } = await this.$http.get('fiscal.get-shipayConfiguration');
                  this.shipay = data;
                  this.modalShipay = false;
                },
                configuration: async () => {
                  await this.$http.post('fiscal.delete-configuracao', {
                    ids: [configuration.id],
                  });
                  const { data } = await this.$http.get('fiscal.get-configuracao');
                  this.configurations = data;
                },
              };

              try {
                this.setLoading(true);
                await (listActions[action] || listActions.configuration)();
                this.setLoading(false);
                this.$alert.success('Configuração removida com sucesso.');
              } catch (e) {
                this.$alert.error(e?.response?.data?.error_message);
                this.setLoading(false);
              }
            },
          });
        },
      );
      return actions;
    },
    editConfiguration(configuration) {
      if (!configuration) {
        this.selected = new ModalConfigurationData({});
        this.modalConfigurations = true;
        return;
      }

      this.selected = new ModalConfigurationData({
        id: configuration.id,
        serie: configuration.serie,
        proximaNota: configuration.proximaNota,
        idTokenCSC: configuration.idTokenCSC,
        tokenCSC: configuration.tokenCSC,
        documento: configuration.modelo,
        ambiente: configuration.ambiente,
        ativo: configuration.ativo,
        printType: configuration.printType,
        codigoAtivacao: configuration.codigoAtivacao,
        versao: configuration.versao,
        assinatura: configuration.assinatura,
        intermediatorNFe: configuration.intermediatorNFe,
        intermediatorNFCe: configuration.intermediatorNFCe,
        satIdentification: configuration.satIdentification,
        RNTRC: configuration.RNTRC,
        typeMDFE: configuration.typeMDFE,
      });

      this.modalConfigurations = false;
      this.modalConfigurations = true;
    },
    env(currentEnv) {
      return AMBIENTE_LABEL[currentEnv];
    },
    getName(modelo) {
      return MODELO_LABEL[modelo];
    },
    isGerencial(configuration) {
      return configuration.documento === MODELO.GERENCIAL;
    },
    async handleSave(form) {
      try {
        this.setLoading(true);
        await this.$http.post(
          form.id ? 'fiscal.put-configuracao' : 'fiscal.post-configuracao',
          form,
        );
        const { data } = await this.$http.get('fiscal.get-configuracao');
        this.configurations = data;
        this.modalConfigurations = false;
        this.setLoading(false);
        this.$alert.success('Configuração salva com sucesso.');
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
        this.selected = form;
        this.setLoading(false);
      }
    },
    editShipay() {
      this.modalShipay = true;
    },
    async handleSaveShipay(form) {
      try {
        this.setLoading(true);
        await this.$http.post('fiscal.post-shipayConfiguration', form);
        const { data: { data } } = await this.$http.get(
          'fiscal.get-shipayConfiguration',
        );

        this.shipay = data;
        this.modalShipay = false;
        this.setLoading(false);
        this.$alert.success('Configuração salva com sucesso.');
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
        this.setLoading(false);
      }
    },
  },
  computed: {
    ...mapState('application', ['loading']),
  },
};
</script>

<style>
.btn .container-button {
  margin-bottom: 30px;
}

.panel.card .card-body {
  min-height: 65px;
}
</style>
